export const formatPrice = (
  value: number,
  options?: {
    currency?: string;
    showUnit?: boolean; // 👈 bật / tắt $
    minimumFractionDigits?: number;
    maximumFractionDigits?: number;
  },
) => {
  if (value === null || value === undefined || isNaN(value)) return '-';

  const {
    currency = 'USD',
    showUnit = true,
    minimumFractionDigits = 0,
    maximumFractionDigits = 2,
  } = options || {};

  // 👉 Không hiện unit
  if (!showUnit) {
    return new Intl.NumberFormat('en-US', {
      minimumFractionDigits,
      maximumFractionDigits,
    }).format(value);
  }

  // 👉 Có unit
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
    minimumFractionDigits,
    maximumFractionDigits,
  }).format(value);
};
